import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { usePublicRaffle } from "../../store/hooks/usePublicRaffle";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { NoActiveRaffle } from "../home/NoActiveRaffle";
import { RaffleFooter, RaffleTemplate } from "../home/RaffleTemplate";
import { Loading } from "../layout/loading";

export const RafflePage = () => {
  const navigate = useNavigate();
  const { raffleId } = useParams<{ raffleId: string }>();

  const logo = useAppSelector(({ account }: RootState) => account.logo);

  const { raffle, isLoading, isUninitialized } = usePublicRaffle(raffleId);

  if (isLoading || isUninitialized) {
    return <Loading title="Buscando rifa" />;
  }

  const backToCatalog = (
    <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate("/")}>
      Ver rifas disponibles
    </Button>
  );

  if (!raffle) {
    return <NoActiveRaffle logo={logo} title="🚫 Rifa no encontrada" action={backToCatalog} />;
  }

  if (raffle.status !== "ACTIVE") {
    return <NoActiveRaffle logo={logo} title="🏁 Esta rifa ya finalizó" action={backToCatalog} />;
  }

  return (
    <>
      <RaffleTemplate raffle={raffle} />
      <RaffleFooter />
    </>
  );
};
